import styled from "styled-components";

export const PriceFilter = styled.div`
  padding: 0 1rem;
`;
